/*
 * @Author: libo 
 * @Date: 2020-11-20 15:16:43 
 * @Last Modified by: mayanxia
 * @Last Modified time: 2022-03-01 10:39:09
 */

<!-- 抄表异常处理查询 -->
<template>
<a-row :gutter="24" class="new-row">
  <a-col :md="collapsed?0: 5" :sm="24" class="new-col">
    <a-card :bordered="false" class="new-tree-card">
      <!-- 按钮操作区域 -->
      <div style="background: #fff;padding-left:16px;height: 100%; margin-top: 5px">
        <a-alert type="info" :showIcon="true">
          <div slot="message">
            {{ $t('当前选择：') }}<span v-if="this.currSelected.title">{{ getCurrSelectedTitle() }}</span>
            <a v-if="this.currSelected.title" style="margin-left: 10px" @click="unselect">{{ $t('取消选择') }}</a>
          </div>
        </a-alert>
        <div style="display: flex;margin-top: 10px;">
          <a-input-search v-model="searchAreaValue" style="width:100%;margin-right: 5px;" allowClear :placeholder="$t('请输入区域名称')"/>
          <a-button type="default" @click="collapseAll">{{ $t('折叠') }}</a-button>
        </div>
        <!-- 树-->
        <a-col :md="24" :sm="24" class="new-tree-col">
          <template>
            <a-spin tip="Loading..." :spinning="areaLoading">
              <!--
              <span style="user-select: none">
                <a-tree
                  class="my-area-select-tree"
                  @select="onSelect"     
                  :selectedKeys="selectedKeys"
                  :treeData="areaTree"
                  :checkStrictly="checkStrictly"
                  :expandedKeys="iExpandedKeys"
                  :autoExpandParent="autoExpandParent"
                  @expand="onExpand">
                  <template slot="title" slot-scope="{title}">
                    <span v-if="title.indexOf(searchAreaValue) > -1">
                      {{title.substr(0, title.indexOf(searchAreaValue))}}
                    <span style="color: #32CD32">{{searchAreaValue}}</span>
                      {{title.substr(title.indexOf(searchAreaValue) + searchAreaValue.length)}}
                    </span>
                    <span v-else>{{title}}</span>
                  </template>
                </a-tree>
              </span>
              -->
              <el-tree
                  class="filter-tree"
                  :data="areaTree"
                  :props="defaultProps"
                  :expand-on-click-node="false"
                  :filter-node-method="filterNode"
                  :check-on-click-node="true"
                  :check-strictly="checkStrictly"
                  :highlight-current="true"
                  node-key="id"
                  :current-node-key="currentNodeKey"
                  :default-expanded-keys="iExpandedKeys"
                  @node-click="nodeClick"
                  ref="areaTree">
                </el-tree>
            </a-spin>
          </template>
        </a-col>
      </div>
    </a-card>
  </a-col>
  <a-col :md="collapsed? 24: 19" :sm="24" style="position: relative;padding-left: 30px" class="new-col">
      <a-icon :type="collapsed ? 'caret-right':'caret-left'" 
        @click="collapsed = !collapsed"
        class="area-collapsed"></a-icon>
    <a-card :bordered="false" class="new-table-card">
      <!-- 查询区域 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline" @keyup.enter.native="searchQuery">
          <a-row :gutter="24">
            <a-col :span="18">
              <a-form-item :label="$t('距今')">
                <a-select v-model="condition" style="width: 30%" @change="handleperiodChange">
                  <a-select-option v-for="meterperiod in conditionData" :key="meterperiod.key" :value="meterperiod.key">
                    {{ meterperiod.title }}
                  </a-select-option>
                </a-select>
                <a-select v-model="punctuation" style="width: 18%;margin-left:5px;">
                  <a-select-option v-for="rate in symbol" :key="rate">
                    {{ rate }}
                  </a-select-option>
                </a-select>
                <a-input-number v-model="queryParam.days" :min="1" :precision="0" style="width: 30%;margin-left:5px;"></a-input-number>
                <a-select v-model="monad" style="width: 10%;margin-left:5px;">
                  <a-select-option v-for="time in units" :key="time">
                    {{ $t(time) }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :xl="6" :lg="7" :md="8" :sm="24">
              <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
                <a-button type="primary" @click="searchQuery" icon="search">{{ $t('查询') }}</a-button>
                <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">{{ $t('重置') }}</a-button>
                <!-- <a @click="handleToggleSearch" style="margin-left: 8px">
                  {{ toggleSearchStatus ? '收起' : '展开' }}
                  <a-icon :type="toggleSearchStatus ? 'up' : 'down'"/>
                </a> -->
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <!-- 操作按钮区域 -->
      <div class="table-operator">
      <a-button type="primary" icon="download" @click="handleExportXls($t('零流量查询'))">{{ $t('导出') }}</a-button>
        <a-dropdown v-if="selectedRowKeys.length > 0">
          <a-menu slot="overlay">
            <a-menu-item key="1" @click="batchDel"><a-icon type="delete"/>{{ $t('删除') }}</a-menu-item>
          </a-menu>
          <a-button style="margin-left: 8px"> {{ $t('批量操作') }} <a-icon type="down" /></a-button>
        </a-dropdown>
      </div>
      <!-- table区域-begin -->
      <div class="table-fixed">
        <div class="ant-alert ant-alert-info" style="margin-bottom: 16px;" v-if="selectedRowKeys.length > 0">
          <i class="anticon anticon-info-circle ant-alert-icon"></i> {{ $t('已选择 {count} 项', { count: selectedRowKeys.length }) }}
          <a style="margin-left: 24px" @click="onClearSelected">{{ $t('清空') }}</a>
        </div>
        <a-table
          ref="table"
          size="middle"
          tableLayout="fixed"
          bordered
          rowKey="userKeyId"
          :columns="columns"
          :dataSource="dataSource"
          :pagination="ipagination"
          :loading="loading"
          class="j-table-force-nowrap"
          :components="drag(columns)"
          @change="handleTableChange">

        </a-table>
      </div>
    </a-card>
  </a-col>
</a-row>
</template>
<script>
import i18n from '@/i18n'
  import { getAction } from '@/api/manage'
  import { mixinDevice } from '@/utils/mixin'
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import {AreaChoosetMixin} from '@/mixins/AreaChooseMixin'
  import moment from 'moment'
  import {getNextDate} from '@/utils/util'
  import TableDragResize  from '@/mixins/TableDragResize'

  const conditionData = [
    //{key: 0,title:'未上报天数'},
    {key: 1,title:i18n.t('未用水天数')},
    //{key: 2,title:'剩余金额'}
  ]
  const cycleData = {
    0:['>='],
    1:['>='],
    2:['<=']
  }
  const timecycleData = {
    0:['天'],
    1:['天'],
    2:['元']
  }
  export default {
    name: 'trafficQueryList',
    mixins:[JeecgListMixin, mixinDevice,AreaChoosetMixin,TableDragResize],
    components: {
    },
    data () {
      return {
        title:"",
        condition:1,
        visible: false,
        cycleData, 
        queryParam:{
          minValue: 0,
          maxValue: 0.1,
          days: 7
        },
        symbol: cycleData['1'],
        punctuation: cycleData['1'],
        units: timecycleData['1'],
        monad: timecycleData['1'],
        description: '零流量查询页面',
        collapsed: false,
        url: {
          list: "/jeecg-charge/meter/waterAnalysis/queryUserInfoByWaterUseZero",
          exportXlsUrl: "/jeecg-charge/meter/waterAnalysis/exportXlsUserInfoByWaterUseZero"
        },
        dictOptions:{},
        disableMixinCreated: true,
        date: []
      }
    },
    created() {
      this.$store.commit('SET_LAYOUT_TREE',true)
      let dayDate = moment(new Date()).format('YYYY-MM-DD');
      this.dayDate = dayDate
      let date = []
      date[0] = moment(getNextDate(dayDate,-7),'YYYY-MM-DD');
      date[1] = moment(getNextDate(dayDate,0),'YYYY-MM-DD');
      let Start = moment(date[0]).format('YYYY-MM-DD');
      let End = moment(date[1]).format('YYYY-MM-DD');
      this.queryParam.beginDate = Start;
      this.queryParam.endDate = End;
      this.loadData();
      //初始化字典配置 在自己页面定义
      this.initDictConfig();
      this.loadTree();
    },
    computed: {
      importExcelUrl: function(){
        return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`;
      },
      // i18n：查询条件（距今）
      conditionData() {
        return conditionData.map(item => ({ ...item, title: this.$t(item.title) }))
      },
      // i18n：表头使用 computed 以响应语言切换
      columns() {
        return [
          {
            title: '#',
            dataIndex: '',
            key:'rowIndex',
            width:60,
            align:"center",
            customRender: (t,r,index) => {
              return parseInt(index)+1;
            },
            scopedSlots: {
            filterDropdown: 'filterDropdown',
            filterIcon: 'filterIcon', }
          },{
            title: this.$t('用户编号'),
            align:"center",
            dataIndex: 'userId',
            width: 150,
            ellipsis: true
          },{
            title: this.$t('用户姓名'),
            align:"center",
            dataIndex:'userName',
            width: 100,
            ellipsis: true,
          },{
            title: this.$t('表编号'),
            align:"center",
            dataIndex: 'meterId',
            width: 150,
            ellipsis: true,
          },{
            title: this.$t('用户地址'),
            align:"center",
            dataIndex: 'userAddr',
            ellipsis: true,
            customRender: (t,r,index) => {
              if(r.userAreaName){
                let i = r.userAreaName.indexOf('-');
                return r.userAreaName.slice(i+1,r.userAreaName.length)+'-'+t;
              }else{
                return t
              }
            },
          },{
            title: this.$t('用水量(m³)'),
            align:"center",
            dataIndex: 'waterUse',
            width: 100,
            ellipsis: true,
          }
        ]
      },
    },
    methods: {
      loadData(arg) {
        //加载数据 若传入参数1则加载第一页的内容
        if (arg === 1) {
          this.ipagination.current = 1;
        }
        let params = this.getQueryParams();//查询条件
        this.loading = true;
        if(this.queryParam.days) {
          let date = moment(getNextDate(this.dayDate,-(this.queryParam.days)),'YYYY-MM-DD');
          params.beginDate = moment(date).format('YYYY-MM-DD');
          delete params['days']
        }
        getAction(this.url.list, params).then((res) => {
          if (res.success && res.result!==null && this.queryParam.days != undefined) {
            this.dataSource = res.result.records;
            this.ipagination.total = res.result.total;
          }
          if(res.code===510){
            this.$message.warning(res.message)
          }
          this.loading = false;
        })
      },
      handleperiodChange(value) {
        this.symbol = cycleData[value];
        this.punctuation = cycleData[value][0];
        this.units = timecycleData[value];
        this.monad = timecycleData[value][0];
        console.log(`selected ${value}`);
      },
      searchReset() {
        this.queryParam = this.$options.data.call(this).queryParam
        let dayDate = this.dayDate
        let date = []
        date[0] = moment(getNextDate(dayDate,-7),'YYYY-MM-DD');
        date[1] = moment(getNextDate(dayDate,0),'YYYY-MM-DD');
        let Start = moment(date[0]).format('YYYY-MM-DD');
        let End = moment(date[1]).format('YYYY-MM-DD');
        this.queryParam.beginDate = Start;
        this.queryParam.endDate = End;
        this.resetAareaData();
        this.loadData(1);
      },
    }
  }
</script>
<style scoped>
  .background{
    background-color:rgb(238,238,238)
  }
  .my-area-select-tree /deep/ li .ant-tree-node-content-wrapper{
    overflow: hidden;
    text-overflow: ellipsis;
    width: 100%;
    white-space: nowrap;
  }
</style>
<style scoped>
  .table-fixed /deep/ .ant-table-bordered .ant-table-fixed-left table{
    border-right: 1px solid #e8e8e8;
  }

.table-fixed /deep/ .resize-table-th {
  position: relative;
}
.table-fixed /deep/ .table-draggable-handle {
  border:1px solid red;
  height: 100% !important;
  left: auto !important;
  right: -5px;
  cursor: col-resize;
  touch-action: none;
  border: none;
  position: absolute;
  transform: none !important;
  bottom: 0;
}

</style>